import React, { useState, useEffect } from 'react';
import { ArrowRight, ExternalLink, ChevronDown } from 'lucide-react';
import { useAbout } from '../hooks/useAbout';

const ROLES = ['AI Engineer', 'Full Stack Developer', 'Automation Specialist'];

function useTypewriter(words, typeMs = 80, deleteMs = 40, pauseMs = 2200) {
  const [text, setText] = useState('');
  const [wordIdx, setWordIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const word = words[wordIdx % words.length];
    let t;

    if (!deleting && text.length < word.length) {
      t = setTimeout(() => setText(word.slice(0, text.length + 1)), typeMs);
    } else if (!deleting && text.length === word.length) {
      t = setTimeout(() => setDeleting(true), pauseMs);
    } else if (deleting && text.length > 0) {
      t = setTimeout(() => setText(word.slice(0, text.length - 1)), deleteMs);
    } else {
      setDeleting(false);
      setWordIdx(i => i + 1);
    }

    return () => clearTimeout(t);
  }, [text, deleting, wordIdx, words, typeMs, deleteMs, pauseMs]);

  return text;
}

export default function Hero() {
  const about = useAbout();
  const role = useTypewriter(ROLES);

  const fullName = about?.name || 'Rupesh Bhatta';
  const nameParts = fullName.trim().split(' ');
  const firstName = nameParts.slice(0, -1).join(' ');
  const lastName = nameParts[nameParts.length - 1];
  const tagline = about?.tagline || 'Building intelligent systems that make a difference.';

  return (
    <section id="hero" className="hero">
      <div className="hero-bg-grid" aria-hidden="true" />
      <div className="container">
        <div className="hero-content">
          <p className="hero-greeting">Hello, World!</p>
          <h1 className="hero-name">
            {firstName && <>{firstName} </>}
            <span className="highlight">{lastName}</span>
          </h1>
          <div className="hero-role" aria-live="polite">
            <span>{role}</span>
            <span className="cursor" aria-hidden="true" />
          </div>
          <p className="hero-tagline">{tagline}</p>
          <div className="hero-cta">
            <a href="#projects" className="btn-primary">
              View My Work <ArrowRight size={16} />
            </a>
            <a
              href="https://blog.rupeshbhatta.com.np"
              target="_blank"
              rel="noreferrer noopener"
              className="btn-outline"
            >
              Read Blog <ExternalLink size={15} />
            </a>
          </div>
        </div>
      </div>
      <a href="#about" className="scroll-indicator" aria-label="Scroll to about">
        <ChevronDown size={22} />
      </a>
    </section>
  );
}
